// ISO datetime strings appended as trailing asOf tokens by use-template-gatherers.
export const ISO_DATETIME_PREFIX = /^\d{4}-\d{2}-\d{2}T/

// Strips the trailing asOf token from a single query key array and joins segments
// into a stable string. Survives intraday clock ticks — only the asOf token changes.
function stableSegmentsFromKey(key: unknown[]): string {
  const flat = key.flat(Infinity) as unknown[]
  const last = flat[flat.length - 1]
  const isAsOfToken = typeof last === "string" && ISO_DATETIME_PREFIX.test(last)
  return (isAsOfToken ? flat.slice(0, -1) : flat).map(seg => JSON.stringify(seg)).join("|")
}

export function buildStableCacheKey(queryKeys: unknown[][]): string {
  return queryKeys.map(stableSegmentsFromKey).join("::")
}
